import { render, staticRenderFns } from "./RelationsTab.vue?vue&type=template&id=2d73070f&scoped=true&"
import script from "./RelationsTab.vue?vue&type=script&lang=js&"
export * from "./RelationsTab.vue?vue&type=script&lang=js&"
import style0 from "./RelationsTab.vue?vue&type=style&index=0&id=2d73070f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d73070f",
  null
  
)

export default component.exports